export const updateToken = () => { return { type: 'UPDATE_TOKEN' } }
